import { useRouteContext } from "@tanstack/react-router";
import type { components } from "#/schema";

export type CurrentUser = components["schemas"]["UserInfoResponse"];

/** The current authenticated user (or null) from the root router context. */
export function useUser(): CurrentUser | null {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.user ?? null });
}

/** Active lessen for this docent (max one per school) from the root router context. */
export function useActiveLessen(): components["schemas"]["ActiveLesModel"][] {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.activeLessen });
}

/** Whether the user has opened the latest release notes — drives the user-menu unread badge. */
export function useHasReadLatestReleaseNotes(): boolean {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.hasReadLatestReleaseNotes });
}

/** Count of tickets with unread admin replies — drives the user-menu unread badge. */
export function useUnreadTicketCount(): number {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.unreadTicketCount });
}

/** Whether the user has the Admin role, derived from the JWT role claim. */
export function useIsAdmin(): boolean {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.isAdmin });
}

/** Whether the session token carries the `impersonation` claim. */
export function useIsImpersonating(): boolean {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.isImpersonating });
}
